import {Vue, Component} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Mall} from 'supporter';
const mallModule = namespace('mall');

@Component
export default class MallInfo extends Vue {
  @mallModule.Getter('malls') private malls!: Mall[];

  public get mallNos(): number[] {
    return this.malls.map((mall: Mall): number => mall.mallNo);
  }

  public get currentMallNo(): number {
    if (this.$route.query.mallNo) {
      return Number(this.$route.query.mallNo);
    } else {
      return this.mallNos[0];
    }
  }
}
